import React, { useState } from 'react';

const WaitlistSize = (props) => {
  const [isSelected, setIsSelected] = useState(false);

  const toggleClass = (e) => {
    if (isSelected) {
      setIsSelected(false);
      props.removeSku(e);
    } else {
      setIsSelected(true);
      props.addSku(e);
    }
  };

  return (
    <span
      className={`WaitlistModal__size ${isSelected ? 'WaitlistModal__size--active' : null} 
          ${props.sizeError ? 'WaitlistModal__size-error' : ''}`}
      onClick={toggleClass}
      data-sku={props.sku}
    >
      {props.size}
    </span>
  );
};

export default WaitlistSize;
